(function($, window, document) {
    "use strict";
    $(function() {
        //##Variables
        var $body = $('body'),
            $window = $(window),
            $doc = $(document),
            $searchArea = $('.search-icon'),
            $header = $('#header'),
            $searchHolder = $('.form-holder'),
            $closeForm = $('.close-form'),
            $mainNav = $('.mainNav'),
            $filter = $('#locations_place'),
            $cityFilter = $('.city_filters'),
            $filterValue = $('#filterValue'),
            $loanCalcForm = $('#calculate-loan'),
            defaultEasing = [0.4, 0.0, 0.2, 1];
        //End Variables

        //Search popup

        $('.calc-btn').on('click', function(e) {
            window.location.href = $('#calc-pages-select').val()
        });


        jQuery('.scrollToForm a[href^="#"]').on('click', function(event) {
            var target = $(this.getAttribute('href'));
            if (target.length) {
                event.preventDefault();
                jQuery('html, body').stop().animate({
                    scrollTop: target.offset().top - 40
                }, 1000);
            }
        });


        $loanCalcForm.on('submit', function(e) {
            e.preventDefault();

            // Look up the input and output elements in the document
            var amount = document.getElementById("amount");
            var apr = document.getElementById("apr");
            var years = document.getElementById("years");
            var months = document.getElementById("months");
            var payment = document.getElementById("payment");
            var total = document.getElementById("total");
            // var totalinterest = document.getElementById("totalinterest");

            // Get the user's input from the input elements.
            // Convert interest from a percentage to a decimal, and convert from
            // an annual rate to a monthly rate. Convert payment period in years
            // to the number of monthly payments. 
            var principal = parseFloat(amount.value);
            var interest = parseFloat(apr.value) / 100 / 12;
            var payments = years.value ? (parseFloat(years.value) * 12) : parseInt(months.value);


            // compute the monthly payment figure
            var x = Math.pow(1 + interest, payments); //Math.pow computes powers
            var monthly = (principal * x * interest) / (x - 1);

            if (isFinite(monthly)) {
                // Fill in the output fields, rounding to 2 decimal places
                payment.innerHTML = monthly.toFixed(2);
                total.innerHTML = (monthly * payments).toFixed(2);
                // totalinterest.innerHTML = ((monthly*payments)-principal).toFixed(2);
            } else {
                // Result was Not-a-Number or infinite, which means the input was
                // incomplete or invalid. Clear any previously displayed output.
                payment.innerHTML = ""; // Erase the content of these elements
                total.innerHTML = ""
                // totalinterest.innerHTML = "";
            }
        })

        $searchArea.click(function() {
            if ($searchHolder.is(':visible')) {
                $body.removeClass('searchArea_opened');
                $searchHolder.fadeIn('fast');
            } else {
                $body.addClass('searchArea_opened');
                $searchHolder.fadeOut('fast');
            }
            $(this).toggleClass('toggled');
            $searchHolder.fadeToggle('fast');
        });
        $closeForm.click(function() {
            $(this).parents('.form-holder').fadeOut('fast');
        });
        $doc.keyup(function(e) {
            if (e.keyCode === 27) {
                $searchHolder.fadeOut('fast');
                $body.removeClass('.form-holder')
            }
        });

        $filter.on('change', function(event) {
            $filterValue.text($(this).val());
            $cityFilter.hide('fast');
            $('.' + $(this).val()).show('fast');
            if ($(this).val() == 'të gjitha') {
                $cityFilter.show('fast');
            }

        });

        $doc.scroll(function() {
            if ($doc.scrollTop() >= $header.outerHeight() + 62) {
                $header.addClass('is--active');
            } else {
                $header.removeClass('is--active');
            }
        });


        //owl carousel

        $('.owl-carousel').owlCarousel({
            loop: true,
            margin: 0,
            dots: true,
            autoplay: true,
            items: 1,
            nav: false,

        })
        $('.backTop').click(function() {
            $('body,html').animate({
                scrollTop: 0
            }, 1000);
        });

        $('.tabs-nav a').on('click', function(event) {
            event.preventDefault();

            $('.tab-active').removeClass('tab-active');
            $(this).parent().addClass('tab-active');
            $('.tabs-stage div').hide();
            $($(this).attr('href')).show();
        });

        $('.tabs-nav a:first').trigger('click'); // Default

        // $('#gallery a').rebox(); 
        $('#gallery').rebox({ selector: 'a' });

        (function() {
            var burger = document.querySelector('.burger-container'),
                header = document.querySelector('.main_header');

            burger.onclick = function() {
                header.classList.toggle('menu-opened');
            }
        }());


        function commaSeparateNumber(val) {
            while (/(\d+)(\d{3})/.test(val.toString())) {
                val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
            }
            return val;
        }


        var a = 0;
        $(window).scroll(function() {

            var oTop = $('#counter').offset().top - window.innerHeight;
            if (a == 0 && $(window).scrollTop() > oTop) {
                $('.counter-value').each(function() {
                    var $this = $(this),
                        countTo = $this.attr('data-count');
                    $({
                        countNum: $this.text()
                    }).animate({
                            countNum: countTo
                        },

                        {

                            duration: 2000,
                            easing: 'swing',
                            step: function() {

                                $this.text(commaSeparateNumber(Math.floor(this.countNum)));
                            },
                            complete: function() {
                                $this.text(commaSeparateNumber(this.countNum));
                                //alert('finished');
                            }

                        });
                });
                a = 1;
            }

        });

        if ($('.inf-scroll').length > 0) {
            $('.inf-scroll').initInfScroll()
        }


        console.log("%c Developed by: Kutia Digital Agency http://kutia.net", "padding:9px 5px; background:#3c4952; line-height:25px;color: #59bf9d");
    });
}(window.jQuery, window, document));